import type { z } from 'zod';
import type { createStudentProfileFormSchema } from '../../pages/(jobportal)/create-curriculum/page';

export const transformCreateCurriculumData = (
  data: z.infer<ReturnType<typeof createStudentProfileFormSchema>>,
) => {
  data.additional_information = data.hasExtraInfo ? data.additional_information : null;
  // data.extra_description = data.hasExtraInfo ? data.additional_information : null;
  data.languages = data.languages
    ? data.languages?.map(language => ({
        language: {
          id: parseInt(language.id),
          name: 'Slovenský jazyk',
          locale: language.locale,
        },
        level: language.level,
        has_file: false,
      }))
    : [];

  // "id": 25,
  // "name": "nazov organizacie",
  // "www": "www stranka",
  // "title": "titul",
  // "date_from": "2010-11-01",
  // "date_to": "2010-11-03",
  // "permanent_education": false,
  // "type": "university", //university,course,high_school
  // "description": "popis",
  // "location": "lokalita",
  // "faculty": "fakulta",
  // "field_of_work": "odbor",
  // "country": {
  //     "id": "SK"
  // }

  data.education =
    data.educations?.map(education => {
      return {
        id: undefined,
        type: education.type,
        name: education.name,
        description: education.description,
        faculty: education.faculty,
        field_of_work: education.field_of_work,
        www: 'www stranka',
        title: education.faculty,
        date_from: `${education.startYear || '2024'}-01-01`, // Start of the year
        date_to: education.endYear ? `${education.endYear || '2024'}-12-31` : null, // End of the year
        permanent_education: false,
        location: education.location,
        country: { id: education.country },
      };
    }) || [];

  data.gender = data.gender ? ({ id: parseInt(data.gender.id), name: 'Muž' } as any) : null;

  data.country = data.country ? ({ id: data.country } as any) : null;

  data.skills = data.skills?.map(skill => ({ name: skill.name, level: skill.level })) || [];
  data.motivation_letter_description &&
    data.skills.push({
      type: 'publication',
      name: 'motivation_letter_description',
      description: data.motivation_letter_description.name,
      level: 'expert',
    });
  // data.video_file &&
  //   data.skills.push({
  //     type: 'publication',
  //     name: 'video_file',
  //     description: data.video_file.name,
  //     file_url: data.video_file.file_url,
  //     ...(data.video_file.file_url ? {} : { file: data.video_file }),
  //     level: 'expert',
  //   });
  data.certificate_description &&
    data.skills.push({
      type: 'publication',
      name: 'certificate_description',
      description: data.certificate_description,
      level: 'expert',
    });
  data.photo_file &&
    data.skills.push({
      type: 'publication',
      name: 'photo_file',
      description: data.photo_file.name,
      file_url: data.photo_file.file_url,
      ...(data.photo_file.file_url ? {} : { file: data.photo_file }),
      level: 'expert',
    });
  data.hobbies &&
    data.skills.push({
      type: 'hobby',
      name: 'hobbies',
      description: data.hobbies,
      level: 'expert',
    });

  Object.keys(data.socials).forEach(key => {
    const social = data.socials[key];
    if (social && (social.url || social.name)) {
      data.skills?.push({
        type: 'honor',
        name: key,
        description: social.url || '',
        company_name: social.name || '',
        level: 'expert',
      });
    }
  });
  data.disciplines =
    data.disciplines?.map(discipline => ({ id: parseInt(discipline.value) })) || [];
  data.driving_licences =
    data.driving_licences?.map(driving_licence => ({ id: parseInt(driving_licence.id) })) || [];
  data.working_hours =
    data.working_hours?.map(working_hour => ({ id: parseInt(working_hour.value) })) || [];
  data.categories = data.categories?.map(category => ({ id: parseInt(category.value) })) || [];
  data.employment_types =
    data.employment_types?.map(employment_type => ({ id: parseInt(employment_type.value) })) || [];
  data.experiences =
    data.experiences
      ?.filter(experience => !!experience.name)
      .map(experience => ({
        ...experience,
        id: undefined,
        date_from:
          experience.startYear && experience.startMonth
            ? `${experience.startYear || '2024'}-${parseInt(experience.startMonth) + 1 || '01'}-01`
            : null,
        date_to:
          experience.endYear && experience.endMonth && !experience.still_working
            ? `${experience.endYear || '2024'}-${parseInt(experience.endMonth) + 1 || '01'}-01`
            : null,
      })) || [];

  return data;
};
